// extracted by mini-css-extract-plugin
module.exports = {"DistrictBlock":"DistrictBlock-module__DistrictBlock___rpQQS"};